import { get, concat, tail, split, join } from "lodash"

export const getRequestName = (
  path: string,
  role: Array<string> | string = []
) => {
  const objectPath = join(concat(tail(split(path, "/")), role), ".")
  return get(SymbolDetail, objectPath)
}

// ルーティングにあわせてパスをつけていく
const SymbolDetail = {
  domestic: {
    summary: "Jpn.Summary.Main",
    index: {
      Main: "Jpn.Index.Main",
      Tse: "Jpn.Index.Tse",
      Emerging: "Jpn.Index.Emerging",
      All: "Jpn.Index.All",
    },
    industry: "Jpn.Industry.Main",
  },
}

// memoのコメント残し
// トップ＞サマリ＞ベンチマーク
// /Message/PriceList?Name=Top.Summary.Benchmark
//   トップ＞サマリ＞株式指数＞ワールド
// /Message/PriceList?Name=Top.Summary.Index.World
//   トップ＞サマリ＞株式指数＞日本
// /Message/PriceList?Name=Top.Summary.Index.Jpn		FIN.20200129
// トップ＞サマリ＞株式指数＞アジア
// /Message/PriceList?Name=Top.Summary.Index.Asian
//   トップ＞サマリ＞株式指数＞その他
// /Message/PriceList?Name=Top.Summary.Index.Other
//   トップ＞サマリ＞株式指数＞全て
// /Message/PriceList?Name=Top.Summary.Index.All
//   トップ＞サマリ＞外国為替
// /Message/PriceList?Name=Top.Summary.FX
//   トップ＞サマリ＞国債
// /Message/PriceList?Name=Top.Summary.GB
//   トップ＞サマリ＞商品
// /Message/PriceList?Name=Top.Summary.Commodity
//   トップ＞サマリ＞政策金利
// /Message/PriceList?Name=Top.Summary.PIR
//   トップ＞主要指数・指標
// /Message/PriceList?Name=Top.Index
//   トップ＞外国為替
// /Message/PriceList?Name=Top.FX
//   トップ＞経済指標
// 	？？？？？
// トップ＞各国金利＞メイン
// /Message/PriceList?Name=Top.GB.Main
//   トップ＞各国金利＞(国指定)
// /Message/PriceList?Name=Top.GB.[国コード2桁]
//   トップ＞商品
// /Message/PriceList?Name=Top.Commodity
//   トップ＞政策金利
// /Message/PriceList?Name=Top.PIR
//
//   国内株式＞サマリ＞国内主要指数・指標
// /Message/PriceList?Name=Jpn.Summary.Main		FIN.20200129
// 国内株式＞国内指数＞主要指標
// /Message/PriceList?Name=Jpn.Index.Main			FIN.20200129
// 国内株式＞国内指数＞東証
// /Message/PriceList?Name=Jpn.Index.Tse			FIN.20200129
// 国内株式＞国内指数＞新興市場
// /Message/PriceList?Name=Jpn.Index.Emerging		FIN.20200129
// 国内株式＞国内指数＞すべて
// /Message/PriceList?Name=Jpn.Index.All			FIN.20200129
// 国内株式＞業種別騰落率＞業種騰落率
// /Message/PriceList?Name=Jpn.Industry.Main		FIN.20200129
//
// 外国株式＞(国指定)＞指数
// /Message/PriceList?Name=FC.[国コード2桁].Index
//   外国株式＞(国指定)＞為替
// /Message/PriceList?Name=FC.[国コード2桁].FX
//   外国株式＞(国指定)＞金利
// /Message/PriceList?Name=FC.[国コード2桁].GB
//   外国株式＞(国指定)＞経済指標
// 	？？？？？
//
// 外国株式＞その他＞指数
// /Message/PriceList?Name=FC.Other.Index
//   外国株式＞その他＞為替
// /Message/PriceList?Name=FC.Other.FX
//   外国株式＞その他＞金利
// /Message/PriceList?Name=FC.Other.GB
//   外国株式＞その他＞経済指標
// 	？？？？？
